import { ofType } from 'redux-observable';
import { concat, EMPTY, of } from 'rxjs';
import { catchError, mergeMap, switchMap, tap } from 'rxjs/operators';

import { PLAYLIST_ENDPOINT_URL } from '../../../common/constants/request';
import { SHARE_VIEW_PATH } from '../../../common/constants/routePath';

import { getPathNameByParams, push } from '../../../common/helpers/history';
import logger from '../../../common/helpers/logger';
import { includeFeatures, tmPostRequest } from '../../../common/helpers/request';
import { getFormattedVideo } from '../../../common/helpers/video';
import { getXRayVideoRequestAction } from '../../../common/redux/slices/common';
import { shareVideoFetchSuccessAction } from '../slices/share';

// TODO: this feature deactivated from 2021 and not tested yet (possible issue)
export default (action$, state$) =>
  action$.pipe(
    ofType(getXRayVideoRequestAction.type),
    switchMap(({ payload }) => {
      const stream$ = tmPostRequest({
        url: PLAYLIST_ENDPOINT_URL,
        body: {
          ...payload,
          ...includeFeatures(state$.value),
        },
      }).pipe(
        mergeMap(({ response }) => {
          const { playlist, errors, ...playerPropsPassThrow } = response ?? {};
          const actions = [];
          const payloadResponse = {
            playerPropsPassThrow,
            playlist: (playlist || []).map((video) =>
              getFormattedVideo(video, {
                signedUrlExp: playerPropsPassThrow.signedUrlExp,
              }),
            ),
          };

          actions.push(of(shareVideoFetchSuccessAction(payloadResponse)));

          if (payloadResponse.playlist.length) {
            actions.push(
              of({ type: '@#' }).pipe(
                tap(() =>
                  push({
                    pathname: getPathNameByParams(SHARE_VIEW_PATH, {
                      video: payloadResponse.playlist[0].mediaid,
                    }),
                  }),
                ),
              ),
            );
          }

          return concat(...actions);
        }),
        catchError((error) => {
          logger.error('modules/PlayerOverview/redux/epics/getXRayOverview', error);

          return EMPTY;
        }),
      );

      return concat(stream$);
    }),
  );
